/**
 * 转场特效 - tv-slice(划像)
 * 2018-10-11
 */

(function (root, factory) {
  if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = factory(this);
  } else {
      factory(root);
  }
})(this, function (root) {
  // 类构造函数
  function con(scene, option) {
    this.code = option.code || 'SliceVertical';
    this.maskEle = $('<div></div>').attr({id: 'maskEle_' + scene.id});
    this.control = {}; // 两个DOM控制对象
  }

  var methods =  {
    init: function (force) {
      this.duration = 0.6; // 动效持续时间
      this.startAt = 0.4; // 开始时间（场景结束前n秒）

      if (this.code === 'SliceCenter') {
        this.duration = 0.7,
        this.startAt = 0.2
      }

      return this.supr(this.startAt, force).then(function () {
      });
    },
    initDom: function() {
      if(!this.maskEle) return;

      var editor = this.scene.editor;

      this.maskEle.hide()
      // svg裁剪元素容器插入播放层的 maskEle 中
      editor.player.maskEle.append(this.maskEle)
      // SVG.js 生成svg元素
      var svgMask = SVG('maskEle_' + this.scene.id).size(editor.clientWidth, editor.clientHeight)
      // 在svg 中生成clipPath元素
      var clipPath = svgMask.defs().clip().attr({
        id: 'slide_' + this.scene.id + '_mask'
      })
      // 定义两个裁剪元素元素属性对象
      var maskFirAttr,
          maskSecAttr;

      switch (this.code) {
        case 'SliceVertical':
          // 左右两个矩形的属性
          maskFirAttr = {
            x: 0, y: 0,
            width: '50%', height: '100%',
            fill: 'black',
            'data-svg-origin': '0 0',
            transform: 'matrix(1,0,0,1,0,'+ editor.clientHeight +')'
          }
          maskSecAttr = {
            x: '50%', y: 0,
            width: '50%', height: '100%',
            fill: 'black',
            'data-svg-origin': editor.clientWidth / 2 +' 0',
            transform: 'matrix(1,0,0,1,0,'+ (-editor.clientHeight) +')'
          }
          break;
        case 'SliceHorizontal':
          // 上下两个矩形的属性
          maskFirAttr = {
            x: 0, y: 0,
            width: '100%', height: '50%',
            fill: 'black',
            'data-svg-origin': '0 0',
            transform: 'matrix(1,0,0,1,'+ editor.clientWidth +',0)'
          }
          maskSecAttr = {
            x: 0, y: '50%',
            width: '100%', height: '50%',
            fill: 'black',
            'data-svg-origin': '0 '+ editor.clientHeight / 2,
            transform: 'matrix(1,0,0,1,'+ (-editor.clientWidth) +',0)'
          }
          break;
        case 'SliceCenter':
          // 中间连个矩形的属性
          maskFirAttr = {
            x: 0, y: 0,
            width: 0, height: '100%',
            fill: 'black',
            'data-svg-origin': '0 0',
            transform: 'matrix(1,0,0,1,'+ editor.clientWidth / 2 +',0)'
          }
          maskSecAttr = {
            x: '50%', y: 0,
            width: 0, height: '100%',
            fill: 'black',
            'data-svg-origin': editor.clientWidth / 2 +' 0',
            transform: 'matrix(1,0,0,1,0,0)'
          }
          break;
        case 'Slice':
          // 一个覆盖全部的矩形，和一个中间的白色裁剪元素
          maskFirAttr = {
            y: -editor.clientHeight/2,
            width: '100%', height: '200%',
            fill: 'black',
            transform: 'matrix(1,0,0,1,0,0)'
          }
          maskSecAttr = $('<div></div>').css({
            height: '150%',
            transform: 'rotate(30deg)',
            width: 0,
            background: '#FFF',
            position: 'absolute',
            left: '50%',
            top: '-25%'
          })
          break;
      }

      // 正式生成第一个裁剪元素的DOM结构并赋值
      this.control.maskFir = clipPath.rect().attr(maskFirAttr)

      // 第二个矩形/裁剪元素生成DOM结构并赋值
      if(this.code !== 'Slice') {
        this.control.maskSec = clipPath.rect().attr(maskSecAttr)
      } else {
        this.maskEle.append(maskSecAttr);
        this.control.maskSec = maskSecAttr;
      }
    },
    show: function(frame) {
      if(!this.isInit) return;
      this.supr(frame);

      var scene = this.scene,
          editor = scene.editor,
          sEle = scene.element.player; // player层的当前 scene

      // 播放层显示，对应scene显示
      editor.player.ele.show();
      sEle.show();
      
      // 衔接上一个场景页的动画(e.g.前0.5s的动画)
      if (frame <= this.entrance.end) {
        this.showFirst(frame)
      }

      // 本场景页的转场动画(e.g.后0.5s的动画)
      if (this.nexts && frame >= this.exit.start) {
          // 隐藏上一个场景页的裁剪元素
          this.prevs && this.prevs.effect.maskEle && this.prevs.effect.maskEle.hide();
          
          var nexts_ele = this.nexts.element.player; // player层中的下一个场景
          var offFrame = frame - this.exit.start; // 当前帧减去动画开始时的帧(动画的帧)

          var val; //为后面计算值提供变量

          this.maskEle.show()
          nexts_ele.show()

          // clipPath 的id绑定，当前场景放大1-1.25，下一个场景缩小1.25-1
          if(this.code === 'Slice') {
            // 对角划像对应的裁剪元素加到本场景
            sEle.css({
              clipPath: 'url("#'+'slide_' + this.scene.id + '_mask' +'")',
              zIndex: scene.index * 5 + 100,
              transform: 'scale('+ this.easeInCubic(offFrame, 1, 0.25, this.totalFrame) +')'
            })
            nexts_ele.css({
              clipPath: '',
              transform: 'scale('+ this.easeInCubic(offFrame, 1.25, -0.25, this.totalFrame) +')'
            })
          } else {
            //其它划像将对应的裁剪元素加到下个场景
            sEle.css({
              clipPath: '',
              zIndex: scene.index,
              transform: 'scale('+ this.easeInCubic(offFrame, 1, 0.25, this.totalFrame) +')'
            })
            nexts_ele.css({
              clipPath: 'url("#'+'slide_' + this.scene.id + '_mask' +'")',
              transform: 'scale('+ this.easeInCubic(offFrame, 1.25, -0.25, this.totalFrame) +')'
            })
          }

          switch (this.code) {
            case 'SliceVertical':
              // 第一个裁剪元素矩形由下到上，第二个裁剪元素矩形由下到上
              val = this.easeInCubic(offFrame, editor.clientHeight, -editor.clientHeight, this.totalFrame);
              this.control.maskFir.attr({
                transform: 'matrix(1,0,0,1,0,'+ val +')'
              })
              this.control.maskSec.attr({
                transform: 'matrix(1,0,0,1,0,'+ (-val) +')'
              })
              break;
            case 'SliceHorizontal':
              // 第一个裁剪元素矩形由右到左，第二个裁剪元素矩形由左到右
              val = this.easeInCubic(offFrame, editor.clientWidth, -editor.clientWidth, this.totalFrame);
              this.control.maskFir.attr({
                transform: 'matrix(1,0,0,1,'+ val +',0)'
              })
              this.control.maskSec.attr({
                transform: 'matrix(1,0,0,1,'+ (-val) +',0)'
              })
              break;
            case 'SliceCenter':
              // 第一个裁剪元素矩形宽度增加位置相应变化，第二个裁剪元素矩形宽度增加
              val = this.easeInCubic(offFrame, 0, editor.clientWidth / 2, this.totalFrame);
              this.control.maskFir.attr({
                width: val + 'px',
                transform: 'matrix(1,0,0,1,'+ (editor.clientWidth / 2 - val) +',0)'
              })
              this.control.maskSec.attr({
                width: val + 'px',
              })
              break;
            case 'Slice':
              // 第一个裁剪元素矩形宽度变窄100-0，x对应变化，旋转角度0-30变化，中间遮罩div宽度增加到画布宽度的1/10
              var calcFrame = offFrame > this.totalFrame / 2 -5 ? this.totalFrame / 2 -5 : offFrame, val2;
              val = this.linear(calcFrame, 0, 30, this.totalFrame/2 - 5);
              val2 = this.linear(offFrame, editor.clientWidth, -editor.clientWidth, this.totalFrame/3*2)
              this.control.maskFir.attr({
                width:  val2,
                x: editor.clientWidth/2 - val2/2,
                transform: 'rotate('+val+', '+editor.clientWidth/2+' '+editor.clientHeight/2+')'
              })
              this.control.maskSec.css({
                width: this.linear(offFrame, 0, editor.clientWidth/10, this.totalFrame/2),
                left: 'calc(50% + -'+ this.linear(offFrame, 0, editor.clientWidth/10, this.totalFrame/2)/2 + 'px)'
              })
              break;
          }
      }

      // 动画外的时间
      if (frame > this.entrance.end && frame < this.exit.start) {
        this.showMiddle()
      }
    },
    showNext: function(frame) {
      var val,
          editor = this.scene.editor,
          _currentFrame = this.startAt * this.frameRate + frame;


      this.maskEle.show()

      if(this.code === 'Slice') {
        // 裁剪元素功成身退
        this.scene.element.player.css({
          clipPath: '',
          zIndex: this.scene.index * 5,
          transform: ''
        }).hide()
        this.nexts.element.player.css({
          transform: 'scale('+ this.easeInCubic(_currentFrame, 1.25, -0.25, this.totalFrame) +')'
        })
      } else {
        this.scene.element.player.css({
          transform: 'scale('+ this.easeInCubic(_currentFrame, 1, 0.25, this.totalFrame) +')'
        })
        this.nexts.element.player.css({
          clipPath: 'url("#'+'slide_' + this.scene.id + '_mask' +'")',
          transform: 'scale('+ this.easeInCubic(_currentFrame, 1.25, -0.25, this.totalFrame) +')'
        })
      }

      // 具体注释如上变化注释
      switch (this.code) {
        case 'SliceVertical':
          val = this.easeInCubic(_currentFrame, editor.clientHeight, -editor.clientHeight, this.totalFrame);
          this.control.maskFir.attr({
            transform: 'matrix(1,0,0,1,0,'+ val +')'
          })
          this.control.maskSec.attr({
            transform: 'matrix(1,0,0,1,0,'+ (-val) +')'
          })
          break;
        case 'SliceHorizontal':
          val = this.easeInCubic(_currentFrame, editor.clientWidth, -editor.clientWidth, this.totalFrame);
          this.control.maskFir.attr({
            transform: 'matrix(1,0,0,1,'+ val +',0)'
          })
          this.control.maskSec.attr({
            transform: 'matrix(1,0,0,1,'+ (-val) +',0)'
          })
          break;
        case 'SliceCenter':
          val = this.easeInCubic(_currentFrame, 0, editor.clientWidth / 2, this.totalFrame);
          this.control.maskFir.attr({
            width: val + 'px',
            transform: 'matrix(1,0,0,1,'+ (editor.clientWidth / 2 - val) +',0)'
          })
          this.control.maskSec.attr({
            width: val + 'px',
          })
          break;
        case 'Slice':
          // 遮罩div宽度变成0
          this.control.maskSec.css({
            width: this.linear(frame, editor.clientWidth/10, -editor.clientWidth/10, this.totalFrame/3),
            left: 'calc(50% + -'+ this.linear(frame, editor.clientWidth/10, -editor.clientWidth/10, this.totalFrame/3)/2 + 'px)'
          })
          break;
      }
    },
    // 清空DOM,以及一些没必要对象
    clearMask: function() {
      this.maskEle.remove();
      this.maskEle = $('<div></div>').attr({id: 'maskEle_' + this.scene.id});
      this.control = {};
      this.isInit = false;
    }
  }

  var statics = {
  }

  if (root.AnimEditor) {
    root.AnimEditor.extendScenesEffect('slice', con, methods, statics);
    return;
  }

  return function (AnimEditor) {
    AnimEditor.extendScenesEffect('slice', con, methods, statics);
  }
});


//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/scene-effects/se-slice.js
// module id = FZxH
// module chunks = 16